export const urlEnum = {
  register: "/app/create",
  registerStatus: "/user/crm/organization",
  senderName: "crm",
  login: "/organization-service/api/auth/signin",
  logout: "/organization-service/api/auth/signout",
  organizations:"/organization-service/api/organizations",
  users:"/organization-service/api/user/administrators",
  deleteUser: "/organization-service/api/user/administrators",
  addAdministratorUser:"/organization-service/api/user/create",
};

export const localUrlEnum = {
  dashboard: "/dashboard",
  login: "/login",
  register: "/register",
  companies: "/companies",
  users: "/users",
};
